<template>
    <div
        class="frame inline"
        :class="{active: active, TA: isTestAchat, left:left}"
        @click="$emit('click')"
    >
        <span class="check-button margin-right" :class="{TA:isTestAchat}"></span>
        <h4 class="weight-normal">{{ title }}</h4>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        active: {
            type: Boolean
        },
        title: {
            type: String
        },
        left: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters("common", ["isTestAchat"])
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Form/CheckButton.vue